import React, { useState, useEffect } from 'react';

/*------------- IMPORTS FROM MATERIAL UI ------------------------------------*/
import Table from 'rsuite/Table';
import Pagination from 'rsuite/Pagination';
import Input from 'rsuite/Input';
import InputGroup from 'rsuite/InputGroup';
import Popover from 'rsuite/Popover';
import Dropdown from 'rsuite/Dropdown';
import Whisper from 'rsuite/Whisper';
import IconButton from 'rsuite/IconButton';
import ButtonToolbar from 'rsuite/ButtonToolbar';
import Loader from 'rsuite/Loader';
import MoreIcon from '@rsuite/icons/legacy/More';
import ReloadIcon from '@rsuite/icons/Reload';
import SearchIcon from '@rsuite/icons/Search';
import AddOutlineIcon from '@rsuite/icons/AddOutline';

/*------------- OTHERS ------------------------------------*/
import { useSelector, useDispatch } from 'react-redux';

/*------------- CUSTOM ------------------------------------*/
import 'Components/Admin/Empresa/table.css';
import { RequestEmpresasAsync, selectIsLoading, selectData, DeleteEmpresaAsync } from 'slices/empresaSlice';
import NewEmpresaModal from '../NewEmpresa/NewEmpresaModal';
import SectionPanel from 'Components/Common/SectionPanel/SectionPanel';
import DelConfirmDialog from 'Components/Admin/Empresa/Empresas/DeleteConfirmDialog';

const { Column, Cell, HeaderCell } = Table;
const PAGE = 1;
const PAGE_SIZE = 11;

export default function EmpresaTable() {
  const dispatch = useDispatch();
  const [openModalForm, setOpenModalForm] = useState(false);
  const [openDelDialog, setOpenDelDialog] = useState(false);
  const [isEdit, setIsEdit] = useState(false);
  const [dataModel, setDataModel] = useState(null);
  const [limit] = useState(PAGE_SIZE);
  const [page, setPage] = useState(PAGE);
  const [searchValue, setSearchValue] = useState('');
  const [filter, setFilter] = useState({
    search: '',
    numberPage: PAGE,
    sizePage: PAGE_SIZE,
  });

  const isLoading = useSelector(selectIsLoading);
  const empresasData = useSelector(selectData);

  const handleEditEmpresa = (data) => {
    setDataModel(data);
    setIsEdit(true);
    setOpenModalForm(true);
  };

  const handleAddEmpresa = () => {
    setIsEdit(false);
    setDataModel(null);
    setOpenModalForm(true);
  };

  const handleSearch = () => {
    setFilter({ ...filter, search: searchValue, numberPage: 1 });
  };

  const handleDeleteEmpresa = (empresaId) => {
    dispatch(DeleteEmpresaAsync(empresaId)).then(() => {
      dispatch(RequestEmpresasAsync(filter));
      setOpenDelDialog(false);
    });
  };

  const handleChangePage = (value) => {
    setPage(value);
    setFilter({ ...filter, numberPage: value });
  };

  const handleRefreshTable = () => {
    setPage(1);
    setSearchValue('');
    setFilter({ ...filter, search: '', numberPage: 1 });
    dispatch(RequestEmpresasAsync({ ...filter, search: '', numberPage: 1 }));
  };

  const ActionCell = ({ rowData, dataKey, ...props }) => {
    return (
      <Cell {...props} className="link-group">
        <Whisper
          placement="autoVerticalStart"
          trigger="click"
          speaker={(props, ref) => {
            const { className, left, top, onClose } = props;
            const handleSelect = (eventKey) => {
              onClose();
              switch (eventKey) {
                case 0:
                  handleEditEmpresa(rowData);
                  break;
                case 1:
                  // dispatch(openModalAction(true));
                  break;
                case 3:
                  setDataModel(rowData);
                  setOpenDelDialog(true);
                  break;
                default:
                  break;
              }
            };
            return (
              <Popover ref={ref} className={className} style={{ left, top }} full>
                <Dropdown.Menu onSelect={handleSelect}>
                  <Dropdown.Item eventKey={0}>Editar Empresa</Dropdown.Item>
                  <Dropdown.Item eventKey={3}>Eliminar Empresa</Dropdown.Item>
                  {/* <Dropdown.Item eventKey={1}>Activar</Dropdown.Item>
                  <Dropdown.Item eventKey={2}>Desactivar</Dropdown.Item> */}
                </Dropdown.Menu>
              </Popover>
            );
          }}
        >
          <IconButton appearance="subtle" icon={<MoreIcon />} />
        </Whisper>
      </Cell>
    );
  };

  const renderLoading = () => {
    return (
      <div>
        <Loader backdrop center content="Cargado" />
      </div>
    );
  };

  useEffect(() => {
    dispatch(RequestEmpresasAsync(filter));
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [filter]);

  return (
    <SectionPanel
      title={
        <div className="table__hader">
          <h4>Configuración de Empresas</h4>
          <div>
            <ButtonToolbar>
              <IconButton appearance="primary" icon={<ReloadIcon />} onClick={handleRefreshTable} />
              <IconButton appearance="primary" icon={<AddOutlineIcon />} onClick={handleAddEmpresa}>
                Nueva Empresa
              </IconButton>
            </ButtonToolbar>
          </div>
        </div>
      }
    >
      <div>
        <NewEmpresaModal isOpen={openModalForm} setOpen={setOpenModalForm} isEdit={isEdit} data={isEdit ? dataModel : null} />
        <DelConfirmDialog
          isOpen={openDelDialog}
          onConfirm={handleDeleteEmpresa}
          onCancel={() => setOpenDelDialog(false)}
          data={dataModel ?? {}}
        />
        <div className="table__hader">
          <div>
            <InputGroup className="table__header-input">
              <Input placeholder="Buscar" value={searchValue} onChange={(value) => setSearchValue(value)} />
              <InputGroup.Button onClick={handleSearch}>
                <SearchIcon />
              </InputGroup.Button>
            </InputGroup>
          </div>
        </div>
        <div className="table__body">
          <Table data={empresasData.items} fillHeight loading={isLoading} renderLoading={renderLoading}>
            <Column flexGrow={1}>
              <HeaderCell>NIT</HeaderCell>
              <Cell fullText dataKey="nit" />
            </Column>
            <Column flexGrow={1}>
              <HeaderCell>NRC</HeaderCell>
              <Cell fullText dataKey="nrc" />
            </Column>
            <Column flexGrow={1}>
              <HeaderCell>Nombre</HeaderCell>
              <Cell fullText dataKey="nombre" />
            </Column>
            <Column flexGrow={1}>
              <HeaderCell>Nombre Comercial</HeaderCell>
              <Cell fullText dataKey="nombreComercial" />
            </Column>
            <Column flexGrow={1}>
              <HeaderCell>Teléfono</HeaderCell>
              <Cell dataKey="telefono" />
            </Column>
            <Column flexGrow={1}>
              <HeaderCell>Correo</HeaderCell>
              <Cell dataKey="correo" />
            </Column>
            {/* <Column flexGrow={1}>
          <HeaderCell>Estatus</HeaderCell>
          <Cell>
            {rowData => (
              rowData.estatus === 100? (<Tag color="yellow">Pendiente</Tag>) : rowData.estatus === 101? <Tag color="green">Activo</Tag> : '-'
            )}
          </Cell>
        </Column> */}
            <Column flexGrow={1}>
              <HeaderCell>
                <MoreIcon />
              </HeaderCell>
              <ActionCell dataKey="id" />
            </Column>
          </Table>
        </div>
        <div style={{ padding: 20 }}>
          <Pagination first next total={empresasData.recordsTotal} limit={limit} activePage={page} onChangePage={handleChangePage} />
        </div>
      </div>
    </SectionPanel>
  );
}
